export default __webpack_public_path__ + "static/media/BE03.2237a5a2.mp3";